// src/components/CustomButton.jsx
import React from "react";
import "../styles/common.css"; // Import global styles

const CustomButton = ({
  label,
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "primary",
  size = "medium",
  className = "",
  ...props
}) => {
  const variantStyles = {
    primary: { backgroundColor: "#007bff", color: "#fff" },
    secondary: { backgroundColor: "#eaeaea", color: "#333" },
    danger: { backgroundColor: "#e00", color: "#fff" },
  };

  const sizeStyles = {
    small: { fontSize: "0.8rem", padding: "6px 12px" },
    medium: { fontSize: "1rem", padding: "10px 18px" },
    large: { fontSize: "1.25rem", padding: "14px 24px" },
  };

  const style = className
    ? {} // If className passed → rely fully on CSS
    : { ...variantStyles[variant], ...sizeStyles[size] }; // Otherwise → use default inline styles

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className || "btn"} // If className passed, use it. Otherwise, use default .btn
      style={style}
      {...props}
    >
      {label || children}
    </button>
  );
};

export default CustomButton;
